/**
 * Created by jv on 2019-09-25 (10:20).
 */
require("slick-carousel/slick/slick.scss");
require("slick-carousel/slick/slick-theme.scss");

const log = require("Sources/utils/logger")();
import utils from "Sources/utils/utils";
import LanguageManager from "Sources/services/language-manager";
import CONSTANTS from "Sources/config/constants";
import "slick-carousel/slick/slick";
import HtmlTemplate from "Views/partials/game/_investment-slider.html";

const iconCardsReq = require.context("!raw-loader!Images/icons/cards", false, /\.svg$/);

require("Styles/components/investment-card.scss");
require("Styles/components/investment-slider.scss");

class InvestmentSlider {
  constructor(options) {
    this.$container = $(options.container);
    this.$element = null;

    this.hasRendered = false;

    this.team = options.team;
    this._roundOverview = options.roundOverview;
    this.hasRedesign = utils.isNotNull(this.roundOverview) ? this.currentRoundData.hasRedesign === true : false;
    this.hasUnlimitedResources = utils.isNotNull(this.roundOverview) ? this.currentRoundData.hasUnlimitedResources === true : false;

    this.investments = options.investments;

    this.hideAnimationTimeout = null;

    this.onInvestmentClicked = options.onInvestmentClicked;
  }

  get roundOverview() {
    return this._roundOverview;
  }

  set roundOverview(roundOverview) {
    this._roundOverview = roundOverview;
    this.hasRedesign = this.currentRoundData.hasRedesign === true;
    this.hasUnlimitedResources = this.currentRoundData.hasUnlimitedResources === true;

    this.updateData();
  }

  get currentRoundData() {
    return this.roundOverview.currentRoundData;
  }

  render() {
    this.hasRendered = false;

    this.$element = $(HtmlTemplate);
    this.$container.append(this.$element);
    LanguageManager.applyLocale(this.$element);

    this.renderSlider();

    this.setUpEventListeners();
  }

  renderSlider() {
    try {
      let $slider = this.$element.find(".investments__slider");
      let slickInitialized = $slider.hasClass("slick-initialized");

      if (slickInitialized) {
        // Remove all slides
        // $slider.slick("slickRemove", null, null, true);
        // Just temporarily remove slick and then add it back in later
        $slider.slick("unslick");
        $slider.empty();
      }

      for (let i = 0; i < this.investments.length; i++) {
        let investment = this.investments[i];
        let isLocked = (investment.redesignNeeded && !this.hasRedesign) || (investment.type === "biomaterials" && !this.hasUnlimitedResources);
        let purchaseCount = InvestmentSlider.getInvestmentPurchaseCount(this.team, this.roundOverview, investment);
        let alreadyPurchased = false;

        if (investment.type === "subsidy") {
          alreadyPurchased = this.roundOverview.currentRoundData.subsidyApproved;
        } else {
          alreadyPurchased = purchaseCount > 0;
        }

        // log.debug("Adding investment card for investment - %o", investment);

        let $investmentCardWrapper = $("<div class='ic__wrapper'></div>");

        let $investmentCard = $("<div class='investment-card investment-card__front'></div>");
        $investmentCard.attr("data-investment-key", investment.key);
        $investmentCard.attr("data-investment-type", investment.type);
        $investmentCard.attr("data-investment-category", investment.category);
        $investmentCard.addClass(`ic__type-${investment.type}`);

        if (isLocked) {
          $investmentCard.addClass("ic-locked");
        }

        if (alreadyPurchased) {
          $investmentCard.addClass("ic-purchased");
        }

        let $cardTop = $("<div class='investment-card__top'></div>");

        let $investmentCost = $("<div class='ic__cost'></div>");
        // NOTE: cost "-1" means that the cost == current round
        let investmentCost = InvestmentSlider.getCostForInvestment(this.roundOverview, investment);
        let $investmentCostValue = $("<div class='ic-data ic-data__budget'></div>");

        if (investment.cost === -1) {
          $investmentCost.addClass("ic__dynamic-cost");
          $investmentCostValue.append("<span class='ic__dynamic-cost-label'>R</span>").append(`<span class="ic__dynamic-cost-value">${investmentCost}</span>`);
        } else {
          $investmentCostValue.text(investmentCost);
        }

        $investmentCost.append($investmentCostValue);

        if (investment.redesignNeeded) {
          $investmentCost.append("<div class='ic-data ic-data__research'></div>");
        }

        $investmentCost.append(`<div class='ic__cost-label'>${LanguageManager.getValueForKey("serious_game.business_model.investments.cost.label")}</div>`);
        $cardTop.append($investmentCost);

        let $investmentIcon = $("<div class='ic__icon'></div>").html(InvestmentSlider.getIconCardForInvestment(investment.type, isLocked));

        let $iconWrapper = $("<div class='ic__icon-wrapper'></div>");
        $iconWrapper.append($investmentIcon);

        $cardTop.append($iconWrapper);

        // $cardTop.append(`<h5 class='ic__title'>${utils.escapeHtml(investment.title)}</h5>`);
        let investmentTitle = LanguageManager.getValueForKey(`serious_game.business_model.investments.front.titles.${investment.type}`);
        $cardTop.append(`<h5 class='ic__title'>${investmentTitle}</h5>`);

        let summary = utils.escapeHtml(investment.summary);

        if (isLocked) {
          if (investment.type === "biomaterials") {
            summary = LanguageManager.getValueForKey("serious_game.business_model.investments.front.locked.unlimited_resources.description");
          } else {
            summary = LanguageManager.getValueForKey("serious_game.business_model.investments.front.locked.product_redesign.description");
          }
        }

        $cardTop.append(`<p class='ic__description'>${summary}</p>`);

        let $cardBottom = $("<div class='investment-card__bottom'></div>");

        let $investmentYield = $("<div class='ic__yield'></div>");
        $investmentYield.append(`<h6 class='ic__yield-label'>${LanguageManager.getValueForKey("serious_game.business_model.investments.yield.label")}</h6>`);

        let approvalTime = 0;

        if (["subsidy"].includes(investment.type)) {
          approvalTime = 1;
        }

        let $approvalNote = $(`<div class="ic__approval-time">${LanguageManager.getValueForKey("serious_game.business_model.investments.approval")}</div>`);

        if (approvalTime === 0) {
          $approvalNote.addClass("visibility-hidden");
        }

        $investmentYield.append($approvalNote);

        let $investmentYieldIcons = $("<div class='ic__yield-icons'></div>");
        $investmentYieldIcons.append(`<div class='ic-data ic-data__points'>${investment.points}</div>`);

        let incomeWithSign = investment.income > 0 ? `+${investment.income}` : investment.income;
        let incomeText = investment.type === "subsidy" ? investment.income : incomeWithSign;

        $investmentYieldIcons.append(`<div class='ic-data ic-data__income'>${incomeText}</div>`);
        $investmentYield.append($investmentYieldIcons);
        $cardBottom.append($investmentYield);

        $investmentCard.append($cardTop).append($cardBottom);
        $investmentCardWrapper.append($investmentCard);

        /*if(slickInitialized)
        {
          $slider.slick("slickAdd", $investmentCardWrapper);
        }
        else
        {
          $slider.append($investmentCardWrapper);
        }*/

        $slider.append($investmentCardWrapper);
      }

      // if(!slickInitialized)
      // {
      //   this.setUpSlick();
      // }

      this.setUpSlick();

      // $slider.slick("slickGoTo", 1);
      this.setUpInvestmentCardClickListener();
    } catch (e) {
      log.error("Failed to render investment slider - %o", e);
    }
  }

  updateData() {
    for (let i = 0; i < this.investments.length; i++) {
      let investment = this.investments[i];
      let isLocked = (investment.redesignNeeded && !this.hasRedesign) || (investment.type === "biomaterials" && !this.hasUnlimitedResources);
      let purchaseCount = InvestmentSlider.getInvestmentPurchaseCount(this.team, this.roundOverview, investment);
      let alreadyPurchased = false;

      if (investment.type === "subsidy") {
        alreadyPurchased = this.roundOverview.currentRoundData.subsidyApproved;
      } else {
        alreadyPurchased = purchaseCount > 0;
      }

      let $investmentCard = this.$element.find(".investment-card[data-investment-key='" + investment.key + "']");

      if (isLocked) {
        $investmentCard.addClass("ic-locked");
      } else {
        $investmentCard.removeClass("ic-locked");
      }

      if (alreadyPurchased) {
        $investmentCard.addClass("ic-purchased");
      } else {
        $investmentCard.removeClass("ic-purchased");
      }

      let investmentCost = InvestmentSlider.getCostForInvestment(this.roundOverview, investment);

      if (investment.cost === -1) {
        $investmentCard.find(".ic__cost").addClass("ic__dynamic-cost");
        $investmentCard.find(".ic-data.ic-data__budget").empty().append("<span class='ic__dynamic-cost-label'>R</span>").append(`<span class="ic__dynamic-cost-value">${investmentCost}</span>`);
      } else {
        $investmentCard.find(".ic-data.ic-data__budget").text(investmentCost);
      }

      let summary = utils.escapeHtml(investment.summary);

      if (isLocked) {
        if (investment.type === "biomaterials") {
          summary = LanguageManager.getValueForKey("serious_game.business_model.investments.front.locked.unlimited_resources.description");
        } else {
          summary = LanguageManager.getValueForKey("serious_game.business_model.investments.front.locked.product_redesign.description");
        }
      }

      $investmentCard.find(".ic__icon").html(InvestmentSlider.getIconCardForInvestment(investment.type, isLocked));
      $investmentCard.find(".investment-card__top .ic__description").html(summary);

      $investmentCard.find(".ic-data.ic-data__points").html(investment.points);

      let incomeWithSign = investment.income > 0 ? `+${investment.income}` : investment.income;
      let incomeText = investment.type === "subsidy" ? investment.income : incomeWithSign;

      $investmentCard.find(".ic-data.ic-data__income").html(incomeText);
    }

    let category = this.$element.find(".category-tab-btn.category-active").data("investment-category");
    this.applyFilter(category);
  }

  setUpSlick() {
    let $slider = this.$element.find(".investments__slider");

    $slider.slick(
      {
        centerMode: true,
        focusOnSelect: false,
        centerPadding: "40px",

        mobileFirst: true,

        draggable: false,
        swipe: true,
        infinite: true,

        // dots: true,
        arrows: true,
        prevArrow: this.$element.find(".investment-slider__arrow-prev"),
        nextArrow: this.$element.find(".investment-slider__arrow-next"),

        slidesToShow: 1,
        slidesToScroll: 1,

        // Without this, adding slides after the initialize is fcked up for some reason:
        // https://github.com/kenwheeler/slick/commit/be0d17cc858fb30e6a4d6b28cc29860c7170040d#comments
        rows: 0,

        // Note breakpoints is actually (breakpoint - 1)
        responsive: [
          {
            breakpoint: 575,
            settings:
              {
                centerMode: true,
                centerPadding: "85px",
                slidesToShow: 1,
                slidesToScroll: 1
              }
          },
          {
            breakpoint: 767,
            settings:
              {
                centerMode: true,
                centerPadding: "150px",
                slidesToShow: 1,
                slidesToScroll: 1
              }
          },
          {
            breakpoint: 899,
            settings:
              {
                centerMode: true,
                centerPadding: "220px",
                slidesToShow: 1,
                slidesToScroll: 1
              }
          },
          {
            breakpoint: 1023,
            settings:
              {
                centerMode: true,
                centerPadding: "320px",
                slidesToShow: 1,
                slidesToScroll: 1
              }
          },
          {
            breakpoint: 1349,
            settings:
              {
                centerMode: true,
                centerPadding: "50px",
                slidesToShow: 3,
                slidesToScroll: 3
              }
          },
          {
            breakpoint: 1439,
            settings:
              {
                centerMode: true,
                centerPadding: "100px",
                slidesToShow: 3,
                slidesToScroll: 3
              }
          },
          {
            breakpoint: 1719,
            settings:
              {
                centerMode: true,
                centerPadding: "100px",
                slidesToShow: 5,
                slidesToScroll: 5
              }
          }
        ]
      });
  }

  show() {
    if (utils.isNotNull(this.$element) && this.$element.length) {
      if (utils.isNotNull(this.hideAnimationTimeout)) {
        clearTimeout(this.hideAnimationTimeout);
        this.hideAnimationTimeout = null;
      }

      this.$container.show();

      let $slider = this.$element.find(".investments__slider");
      $slider.slick("resize");
      $slider.slick("setPosition");
    }
  }

  hide() {
    if (utils.isNotNull(this.$container) && this.$container.length) {
      if (utils.isNotNull(this.hideAnimationTimeout)) {
        clearTimeout(this.hideAnimationTimeout);
        this.hideAnimationTimeout = null;
      }

      this.hideAnimationTimeout = setTimeout(() => {
        this.hideAnimationTimeout = null;
        this.$container.hide();
      }, CONSTANTS.BM_TRANSITION_SPEED);
    }
  }

  destroy() {
    if (utils.isNotNull(this.$element) && this.$element.length) {
      this.$element.remove();
    }
  }

  setUpEventListeners() {
    this.$element.find(".category-tab-btn").off("click").on("click", (e) => {
      let $this = $(e.currentTarget);
      let category = $this.data("investment-category");

      this.$element.find(".category-tab-btn").removeClass("category-active");
      $this.addClass("category-active");

      this.applyFilter(category);
    });
  }

  applyFilter(category) {
    log.info("Filtering investments for category [%s]", category);

    if (category === "all") {
      this.$element.find(".investments__slider").slick("slickUnfilter");
    } else {
      this.$element.find(".investments__slider").slick("slickFilter", function (index) {
        return !$(this).find(".investment-card").hasClass("ic-purchased");
      });
    }
  }

  setUpInvestmentCardClickListener() {
    this.$element.find(".investment-card").on("click", (e) => {
      let $this = $(e.delegateTarget);
      let investmentKey = $this.data("investment-key");
      let $slickSlide = $this.closest(".slick-slide");

      console.log("Clicked - %s", investmentKey);

      let investment = this.getInvestmentForKey(investmentKey);

      // Only allow to click on the active slides
      if (utils.isNotNull(investment) && $slickSlide.hasClass("slick-active")) {
        let isLocked = (investment.redesignNeeded && !this.hasRedesign) || (investment.type === "biomaterials" && !this.hasUnlimitedResources);

        if (!isLocked) {
          if (utils.isFunction(this.onInvestmentClicked)) {
            this.onInvestmentClicked.call(this, investment);
          }
        }
      }
    });
  }

  static getCostForInvestment(roundOverview, investment) {
    let investmentCost = investment.cost === -1 ? roundOverview.currentRoundData.roundIndex : investment.cost;

    // NOTE: hardcoded price change (also in investment-dialog)
    if (utils.isNotNull(roundOverview.currentEvent) && roundOverview.currentEvent.type === "subsidy" && ["productredesign", "extraproduct"].includes(investment.type)) {
      investmentCost += roundOverview.currentEvent.jsonData.value;
    }

    return investmentCost;
  }

  static canPurchaseInvestment(team, roundOverview, investments, investment) {
    let investmentCost = InvestmentSlider.getCostForInvestment(roundOverview, investment);
    let canPurchase = roundOverview.currentRoundData.currentBudget >= investmentCost && utils.isNull(roundOverview.currentRoundData.investmentKey2);

    if (investment.type !== "subsidy") {
      let purchaseCount = InvestmentSlider.getInvestmentPurchaseCount(team, roundOverview, investment);

      if (purchaseCount > 0) {
        canPurchase = false;
      }
    } else {
      canPurchase = canPurchase && InvestmentSlider.canPurchaseSubsidy(team, roundOverview, investments);
    }

    return canPurchase;
  }

  static getInvestmentPurchaseCount(team, roundOverview, investment) {
    let purchaseCount = 0;

    for (let roundIndex in team.roundData) {
      // Only check rounds that have been started
      if (team.roundData.hasOwnProperty(roundIndex) && utils.isNotNull(team.roundData[roundIndex].started) && team.roundData[roundIndex].roundIndex <= roundOverview.currentRoundData.roundIndex) {
        let roundData = team.roundData[roundIndex];

        if (roundData.investmentKey1 === investment.key || roundData.investmentKey2 === investment.key) {
          purchaseCount++;
        }
      }
    }

    return purchaseCount;
  }

  static canPurchaseSubsidy(team, roundOverview, investments) {
    let subsidyInvestment = InvestmentSlider.getInvestmentForType(investments, "subsidy");

    if (utils.isNull(subsidyInvestment)) return false;

    let subsidiesPurchased = InvestmentSlider.getInvestmentPurchaseCount(team, roundOverview, subsidyInvestment);
    let subsidyApproved = roundOverview.currentRoundData.subsidyApproved;

    if (subsidyApproved) {
      return false;
    } else {
      // Can't purchase same investment twice in 1 round
      if (roundOverview.currentRoundData.investmentKey1 === subsidyInvestment.key) return false;
      return subsidiesPurchased < 2;
    }
  }

  static getInvestmentForType(investments, type) {
    for (let i = 0; i < investments.length; i++) {
      if (investments[i].type === type) {
        return investments[i];
      }
    }

    return null;
  }

  getInvestmentForKey(key) {
    if (utils.isNull(key)) return null;

    for (let i = 0; i < this.investments.length; i++) {
      if (this.investments[i].key === key) {
        return this.investments[i];
      }
    }

    return null;
  }

  static getIconCardForInvestment(investmentType, locked) {
    let requireKey = `./${investmentType}.svg`;

    if (!locked && iconCardsReq.keys().includes(requireKey)) {
      return iconCardsReq(requireKey);
    }

    return iconCardsReq("./sloticon.svg");
  }
}

export default InvestmentSlider;



// WEBPACK FOOTER //
// ./app/js/components/game/components/investment-slider.js